export default __webpack_public_path__ + "static/media/BudgetWorksheet.07d34dab.png";